import styles from "../../../../assets/styles/Document.module.scss";

import DocumentLines from "./DocumentLines";
import DocumentLogo from "./DocumentLogo";
import DocumentCust from "./DocumentCust";
import DocumentRef from "./DocumentRef";
import formatMoney from "../../../../utils/formatMoney";

export default function DocumentWrapper({
  selected,
  statements,
  pageno,
  pages,
  getTotalDue,
}: any) {
  return (
    <div className="flex justify-center" id="invoice-doc">
      <div className={styles.wrapper}>
        <DocumentLogo />
        <DocumentRef title="Statement" date={new Date()} selected={selected} />
        <DocumentCust customer={statements[0]} pageno={pageno} pages={pages} />
        <div className="my-2 font-bold">
          Dear Customer, Please pay your bills on time.
        </div>

        <DocumentLines items={statements} currencyFormatter={formatMoney} />
        {pageno === pages ? (
          <div className="border border-black  text-xs">
            <div className="grid grid-cols-12 border-t  border-black  bg-white">
              <div className="col-span-10 p-1 font-bold border-r border-black  text-right">
                Total Amount Due
              </div>
              <div className="col-span-2 py-1 font-bold text-right">
                {formatMoney(getTotalDue())}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
